import { Injectable, computed } from '@angular/core';
import { ChatHolderService } from './../chat/chat.holder.service';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private chatHolderService: ChatHolderService) {}

  currentCoreId = computed(() => {
    const currentChat = this.chatHolderService.currentChat();

    if (currentChat) {
      return currentChat.id;
    }
    return undefined;
  });
}
